import React, { useState, useEffect } from 'react';
import "../../styles/Doctor-ui/Searchbar.css";
import PatientDetails from './DA-PatientDetails';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Cookies from "js-cookie";
import { API_DETAILS, COOKIE_KEYS } from '../../App';
import {
  getLastViewedPatient,
  setLastViewedPatient,
  clearLastViewedPatient,
} from '../../utils/lastViewedPatient';

const SearchBar = () => {
  const [searchInput, setSearchInput] = useState('');

  const [showdetails, setshowdetails] = useState(false);

  const [patientData, setPatientData] = useState(null);
  const [userDetails, setUserDetails] = useState([]);
  const [consulted, setConsulted] = useState(false);
  const [myPats, setMyPats] = useState([]);
  // "loading" until the list arrives, so an empty screen is never mistaken for
  // "no patients".
  const [listState, setListState] = useState("loading");


  const navigate = useNavigate();
  let { patientId } = useParams();

  const handleViewMore = (id) => {
    navigate(`${id}`)
    setSearchInput('');
  };

  const handlesearchdetails = (e) => {
    if (e.key === 'Enter') {
      setshowdetails(false)
    }
  };

  const hitback = () => {
    setshowdetails(false);
    // Deliberately leaving a chart clears the memory. Without this the effect
    // below would send you straight back into the patient you just left, and
    // the list would be unreachable.
    clearLastViewedPatient();
    navigate("..", {relative: "path"})
  }

  // Remember which chart was open so leaving Patient Details and coming back
  // returns to it instead of the patient list. Session-scoped: it should follow
  // this sitting, not persist across a new sign-in.
  useEffect(() => {
    if (patientId) {
      setLastViewedPatient(patientId);
    }
  }, [patientId])

  useEffect(() => {
    if (patientId) return;

    const remembered = getLastViewedPatient();

    if (remembered) {
      // replace so Back still leaves Patient Details rather than bouncing
      // between the list and the remembered chart.
      navigate(remembered, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId])

  // Every patient, once, when the list opens; typing filters what is already
  // here. The server sends only what the list shows — name, email and last
  // appointment — rather than the full records /getAllUsers used to send.
  useEffect(() => {
    if (patientId) return;
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId])

  // USED useEffect twice
  useEffect(() => {
    if (patientId) {
      setshowdetails(true)
    } else {
      setshowdetails(false)
    }
  }, [patientId])

  const fetchUsers = async () => {
    const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/searchPatients`;
    try {
      const res = await axios.get(url);
      setUserDetails(res.data);
      setListState("loaded");
    }
    catch (err) {
      setUserDetails([]);
      setListState("failed");
    }
  }


  const handleConsultByMe = async () => {

    const uId = Cookies.get(COOKIE_KEYS.userId).trim();
    const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getPatientsByDoctor/${uId}`;
    const config = {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
        'Content-Type': 'application/json'
      }
    };
    try {
      const res = await axios.get(url, config);
      setMyPats(res.data);
    }
    catch (err) {
    }
  }

  const handleChange = (e) => {
    // console.clear();
    setSearchInput(e.target.value);
  };

  const matches = (value) => (value || '').toLowerCase().includes(searchInput.trim().toLowerCase());

  const filteredpatients = consulted 
    ? myPats.filter((patient) => matches(patient.firstName) || matches(patient.email))
    : userDetails
      .filter((patient) => matches(patient.firstName) || matches(patient.lastName) || matches(patient.email))
      .sort((a, b) => {
        const dateA = new Date(a.lastAppointmentDate);
        const dateB = new Date(b.lastAppointmentDate);
        return dateB - dateA;
      });

  return (<>
    <div className='search-bar'>
      
      <div className='search-input'>
        {!showdetails && <div>
        <input id='consulted' onClick={() => { setConsulted(!consulted); handleConsultByMe(); }} type='checkbox'></input>
        <label htmlFor='consulted'>Consulted by me</label>
        </div>}
        
        {!showdetails && <input
          className='search-input-field'
          type="search"
          placeholder="Search here by name"
          onChange={handleChange}
          onKeyDown={handlesearchdetails}
          value={searchInput}
        />}
        {/* <span className="icon">🔍</span> */}
      </div>
      <div className='patient-details'>
        {showdetails ? (
          <div className='details-container'>
            <PatientDetails />
          </div>
        ) : (
          <>
            {
              consulted ?
                <div>
                  {filteredpatients.map((patient) => (
                    <div key={patient.userId} className='patient-details-1'>
                      <div className='column-details'>
                        <label className='label-pd'>{patient.firstName}</label>
                        <label className='label-pd'>{patient.email}</label>
                      </div>
                      <div className='view-more'>
                        {/* <button className='btn-filled' onClick={() => handleViewMore(patient.userId)}>View More</button> */}
                        <button onClick={() => handleViewMore(patient.userId)} className='view-more-class' style={{backgroundColor: 'inherit'}} >
                                                            View More {'>>'}
                                                        </button>
                      </div>
                    </div>
                  ))}
                </div> :
                <div>
                  {listState === "loading" ? (
                    <p className='search-hint'>Loading patients…</p>
                  ) : listState === "failed" ? (
                    <p className='search-hint'>We couldn't load the patient list. Refresh the page to try again.</p>
                  ) : filteredpatients.length === 0 ? (
                    <p className='search-hint'>
                      {searchInput.trim() ? `No patient matches "${searchInput.trim()}".` : "No patients yet."}
                    </p>
                  ) : filteredpatients.map((patient) => (
                    <div key={patient.userId} className='patient-details-1'>
                      <div className='column-details'>
                        <label className='label-pd'>{patient.firstName}</label>
                        <label className='label-pd'>{patient.email}</label>
                      </div>
                      <div className='view-more'>
                        <button className='btn-filled' onClick={() => handleViewMore(patient.userId)}>View More</button>
                      </div>
                    </div>
                  ))}
                </div>
            }
          </>
        )}
      </div>
    </div>
  </>

  );
};

export default SearchBar;
